module.exports = __webpack_public_path__ + "static/media/Group_3652.6da1684e.png";